import { render, staticRenderFns } from "./CardEditForm.vue?vue&type=template&id=70839527&scoped=true"
import script from "./CardEditForm.vue?vue&type=script&lang=js"
export * from "./CardEditForm.vue?vue&type=script&lang=js"
import style0 from "./CardEditForm.vue?vue&type=style&index=0&id=70839527&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70839527",
  null
  
)

export default component.exports